<div
  class="wk8-book-sentence-builder"
  style="
    width: 100%;
    height: 100%;
    position: relative;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 2.5em;
    user-select: none;
    font-size: 2em;
  "
>
  <div class="background" style="position: absolute; inset: 5%">
    <img src="/assets/woordkr8/sprites/book.png" alt="" />
  </div>

  <div
    class="book"
    style="position: absolute; inset: 10%; display: grid; grid-template-columns: 1fr 1fr; place-items: center; align-content: center"
  >
    <div class="options" style="position: relative; display: grid; grid-auto-flow: column; justify-content: space-evenly; width: 100%">
      @for (option of options(); track option.uid) {
        <div #draggableDivs lpDraggable [dragContent]="option" [alwaysShadow]="true">
          <div [class.wiggle]="option.uid !== chosenWord()?.uid">
            <ng-container [ngTemplateOutlet]="word" [ngTemplateOutletContext]="{ options: options(), value: option.word }"></ng-container>
          </div>
        </div>
      }
    </div>

    @let _book = book();
    @if (_book) {
      <wk8-book-contents
        [book]="_book"
        [target]="target()"
        [highlightedSentence]="_wk8GlobalsService.currentLevel?.sentence"
        mode="WORD_FILL"
        (wordFilled)="setWord($event[0], $event[1])"
        style="display: block; position: relative; justify-self: left; padding-left: 12%"
      />
    }
  </div>

  @if (isWordFilled()) {
    <img
      class="clickable"
      src="/assets/woordkr8/sprites/next-board-button.png"
      style="position: absolute; right: 0; bottom: 0; width: 15%"
      (click)="finish()"
      @slidedown
    />
  }
</div>

<ng-template #word let-options="options" let-value="value" let-target="target">
  <wk8-paper-piece style="display: inline-block">
    <div class="sizer" style="visibility: hidden; display: grid; grid-template-areas: 'stack'">
      @for (o of options; track o.uid) {
        <div style="grid-area: stack">{{ o.word }}</div>
      }
    </div>
    @if (value === undefined) {
      <div
        style="position: absolute; inset: 0; visibility: visible; border: 4px dotted black; border-radius: 0.25em; margin-inline: 0.5ch"
        [style]="{ borderColor: target ? 'white' : 'black' }"
      ></div>
    }
    <div
      class="content"
      style="position: absolute; inset: 0; place-self: center; text-align: center; font-weight: bold; font-style: italic"
    >
      {{ value }}
    </div>
  </wk8-paper-piece>
</ng-template>
